export default "/images/vendor/flag-icon-css/flags/1x1/tz.svg?20af2614818e325d953d7ed0c602923c";